import React, { useState, useEffect } from "react";
import Container from "../../Container/Container";
import "./Preview.scss";
import Buttons from "../../components/Button/Button";
import { useHistory } from "react-router";
import Modals from "../../components/Modal/Modal";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Langtrans from "../../components/Langtrans/Langtrans";
import parse from "html-react-parser";
import Snackbar from "../../components/Snackbar/Snackbar";
import { campaignData, draftId } from "../../store/action";
import Logo from "../../assets/LAETUS.png";

const Preview = () => {
  const history = useHistory();
  const campaign = useSelector((state) => state.campaign.campaign);
  const state = useSelector((state) => state);

  const product = useSelector((state) => state.product);
  const productID = useSelector((state) => state.draftId.draftProductId);
  const [openmodal, setopenmodal] = useState(false);
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const dispatch = useDispatch();
  const describeroute = () => {
    history.push("/describecampaign");
  };

  useEffect(() => {
    if (product?.frontImg) {
      history.push("/");
    }
  }, []);
  const launchmodal = async () => {
    setopenmodal(true);
  };
  // console.log("product", product);
  const { t } = useTranslation();
  const AddtoCart = (Data) => {
    // console.log("card", Data);
    dispatch(
      draftId({
        draftProductId: "",
      })
    );
    const exist = campaign?.find((item) => item.id === Data?.id);
    if (exist) {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: campaign.map((x) =>
            x.id === Data?.id ? { ...exist, quantity: exist.quantity + 1 } : x
          ),
        })
      );
    } else {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: [...campaign, { ...Data, quantity: 1 }],
        })
      );
    }
  };
  return (
    <>
      <Container>
        {/* <Langtrans login trans /> */}
        <div className="preview-header">
          <div
            className="preview-logo cp"
            onClick={() => history.push("/home")}
          >
            <img src={Logo} alt="logo" height={130} />
          </div>
          <div>
            <Buttons
              text={`< ${t("modifier")}`}
              className="modifier btn"
              onClick={() => describeroute()}
            />
            <Buttons
              text={`${t("launch_campaign")} >`}
              className="campaign-btn btn"
              onClick={() => launchmodal()}
            />
          </div>
        </div>
      </Container>
      <div className="preview-mid">
        <Container>
          <h2>{t("preview")}</h2>
          <p>{t("appearence")}</p>
        </Container>
      </div>
      <Container>
        <div className="campaign">
          <div>
            <div className="shirt">
              <img
                src={product.designnimg}
                alt="shirt"
                width={500}
                height={500}
              />
            </div>
          </div>
          <div className="description-preview">
            <p className="days">
              {product.day} {t("days_left")}
            </p>
            <h3>{product.shirtname}</h3>
            <p className="price">{product.sellingPrice} €</p>
            <p className="prototype" style={{ wordBreak: "break-word" }}>
              {product.brief}
            </p>
          </div>
          <div className="card-main">
            <div className="card" style={{ maxWidth: "450px" }}>
              <div
                className="card-content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "185px",
                  width: "450px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    height: "80%",
                  }}
                >
                  <div>
                    <img
                      src={product.designnimg}
                      alt="t-shirt"
                      className="item-img"
                      width={150}
                      height={150}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "left",
                        fontWeight: "600",
                        fontSize: "1.125rem",
                      }}
                    >
                      COMMANDEZ DES ECHANTILLONS AVANT DE LANCER VOTRE CAMPAGNE!
                    </div>
                    <Buttons
                      style={{ marginTop: "10px" }}
                      text={`${t("ord")}`}
                      onClick={() => AddtoCart(product)}
                    />
                  </div>
                </div>
                <div
                  style={{
                    height: "20%",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      paddingRight: "15px",
                      fontSize: "0.9rem",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <del>{product.sellingPrice} €</del>
                  </div>
                  <p
                    style={{
                      color: "#E3655B",
                      fontSize: "1.125rem",
                      fontWeight: "600",
                    }}
                  >
                    {product.realprice} €
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="berief-desc">
					<h2>{t("additional_inform")}</h2>
					<div>{product.detail && parse(JSON.parse(product.detail))}</div>
				</div> */}
        <Modals
          condition="launch"
          setopenmodal={setopenmodal}
          openmodal={openmodal}
        />
      </Container>
      {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
    </>
  );
};
export default Preview;
